import {
  AUTHORIZATION_ACTION_OPTION,
  AUTHORIZATION_STATUS,
} from "./authorization-constant";

type AuthorizationActionOption = { value: string; label: string };

/** Archive is offered only once a prior auth is Inactive; archived rows can only be viewed or unarchived. */
export const getAuthorizationActionOptions = (
  status: string | undefined,
  isArchived: boolean
): AuthorizationActionOption[] => {
  const { VIEW, EDIT, ARCHIVE, UNARCHIVE } = AUTHORIZATION_ACTION_OPTION;
  if (isArchived) return [VIEW, UNARCHIVE];
  if (status === AUTHORIZATION_STATUS.INACTIVE) return [VIEW, EDIT, ARCHIVE];
  return [VIEW, EDIT];
};
